import { useState } from 'react';
import { FiX, FiCopy, FiEye, FiEyeOff } from 'react-icons/fi';
import { Modal } from './Modal';
import { useI18n } from '../i18n/useI18n';

export function PrivateKeyModal({ open, onClose, privateKey, pushToast }) {
  const { t } = useI18n();
  const [showKey, setShowKey] = useState(false);
  const [copied, setCopied] = useState(false);

  if (!open) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(privateKey).then(() => {
      setCopied(true);
      pushToast(t('privateKey.copied'), 'success');
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('privateKey.title')}
      maxWidthClass="max-w-md"
    >
      <div className="p-6 space-y-6">
        <div className="p-4 bg-rose-500/10 border border-rose-500/20 rounded-xl">
          <h4 className="text-sm font-bold text-rose-400 mb-2">{t('privateKey.warningTitle')}</h4>
          <p className="text-xs text-rose-300/80 leading-relaxed">
            {t('privateKey.warningLine1')}
            <br/>
            {t('privateKey.warningLine2')}
          </p>
        </div>

        <div className="space-y-2">
          <label className="text-xs font-medium text-slate-400">{t('privateKey.yourKey')}</label>
          <div className="relative group">
            <div className={`
              w-full p-4 pr-24 bg-slate-950 border border-slate-800 rounded-xl 
              font-mono text-sm break-all transition-colors
              ${showKey ? 'text-slate-200' : 'text-slate-600 select-none blur-[2px] group-hover:blur-none group-hover:text-slate-500'}
            `}>
              {showKey ? privateKey : '••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••'}
            </div>
            
            <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-1">
              <button
                onClick={() => setShowKey(!showKey)}
                className="p-2 rounded-lg bg-slate-900 hover:bg-slate-800 text-slate-400 hover:text-white transition-colors border border-slate-800"
                title={showKey ? t('privateKey.hide') : t('privateKey.show')}
              >
                {showKey ? <FiEyeOff size={16} /> : <FiEye size={16} />}
              </button>
              <button
                onClick={handleCopy}
                className="p-2 rounded-lg bg-sky-500/10 hover:bg-sky-500/20 text-sky-400 hover:text-sky-300 transition-colors border border-sky-500/20"
                title={t('privateKey.copy')}
              >
                {copied ? <span className="text-xs font-bold">{t('privateKey.copiedShort')}</span> : <FiCopy size={16} />}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="px-6 py-4 border-t border-slate-800 bg-slate-900/50 flex justify-end">
        <button
          onClick={onClose}
          className="px-4 py-2 rounded-lg bg-slate-800 hover:bg-slate-700 text-white text-sm font-medium transition-colors"
        >
          {t('privateKey.close')}
        </button>
      </div>
    </Modal>
  );
}
